import "./About.css";
import { FaDownload } from "react-icons/fa";
function About() {
  return (
    <section className="about-section">
      <div className="about-container">

        <div className="about-left">
          <span className="section-tag">ABOUT ME</span>

          <h2>
            Video Editor &
            <br />
            Cinematographer
          </h2>

          <p>
            Passionate Video Editor and Cinematographer with
            experience in creating high-quality visual content.
            Skilled in storytelling, color grading, motion graphics
            and producing engaging videos for brands and social media.
          </p>

          <p>
            I focus on delivering creative and impactful content
            that captures attention and communicates ideas effectively.
          </p>
        </div>

        <div className="about-right">
          <div className="info-card">
            <h4>Personal Information</h4>

            <div className="info-row">
              <strong>Name:</strong>
              <span>Mahad Nadeem</span>
            </div>

            <div className="info-row">
              <strong>Profession:</strong>
              <span>Video Editor &
Cinematographer</span>
            </div>

            <div className="info-row">
              <strong>Experience:</strong>
              <span>4+ Years</span>
            </div>

            <div className="info-row">
              <strong>Location:</strong>
              <span>Pakistan</span>
            </div>

           <a
  href="/resume.pdf"
  download="Mahad-Nadeem-CV.pdf"
  className="cv-btn"
>
  <FaDownload style={{ marginRight: "8px" }} />
  Download CV
</a>
          </div>
        </div>

      </div>
    </section>
  );
}

export default About;